import { createSlice } from '@reduxjs/toolkit'
import { initialState } from './state'
import { reducers } from './reducers'

export const adminSlice = createSlice({
  name: 'users',
  initialState,
  reducers
})

export const {
  // --------------- Generate Certificates -------
  setGenerateCertificateLoading,
  setGenerateCertificateResponse,
  setGenerateCertificateError,

  // ---------------------- Admin Statics ---------
  setAdminStaticsLoading,
  setAdminStaticsData,
  resetAdminStaticsData,

  // ----------- Massive Calculations -------------
  resetMassiveCalculationFileData,
  resetMassiveCalculationKeys,
  resetMassiveCalculationState,
  setMassiveCalculationCarKeys,
  setMassiveCalculationExcelData,
  setMassiveCalculationFileName,
  setMassiveCalculationKeys,
  setMassiveCalculationLoadingPreview,
  setMassiveCalculationNextButtonDisabled,
  setMassiveCalculationParcelKeys,
  setMassiveCalculationPlaneKeys,
  setMassiveCalculationPreviewList,
  setMassiveCalculationResponseAddData,
  setMassiveCalculationResponseErrorMessage,
  setMassiveCalculationResponseLoading,
  setMassiveCalculationResponseResetData,
  setMassiveCalculationStep,
  setMassiveCalculationUrl,

  // ----------- Brokerage Slice Reducers -------
  setBrokerageSelectedTag,
  setBrokerageSalePriceCurrency,
  setBrokeragePurchasePriceCurrency,

  // ---------- Admin Users Reducers -----------
  setAdminUsersLoading,
  setAdminUsersData,
  resetAdminUsersState,
  setAdminUsersTextFilter,
  setAdminUsersFilterTypeOption,
  setAdminUsersFilterStatusOption,
  setAdminUsersFilterGroupOption,

  // Validate User Reducers
  setValidateUserLoading,
  setValidateUserSuccess,
  setValidateUserError,
  resetValidateUserState,
  setValidateUserCurrentId,

  // -------- Reject User ---------
  setRejectUserLoading,
  setRejectUserSuccess,
  setRejectUserError,
  resetRejectUserState,
  setRejectUserCurrentId,

  //  ----------------------Withdrawal --------------------
  resetWithdrawalState,
  setWithdrawalsLoading,
  setWithdrawalsData,
  setWithdrawalsFilterStatus,
  setWithdrawalsFilterText,

  // Validate Withdrawal
  resetValidateWithdrawalState,
  setValidateWithdrawalsLoading,
  setValidateWithdrawalsSuccess,
  setValidateWithdrawalsError,
  setValidateCurrenctWithdrawalId,

  // Cancel Withdrawal
  resetCancelWithdrawalState,
  setCancelWithdrawalsLoading,
  setCancelWithdrawalsSuccess,
  setCancelWithdrawalsError,
  setCancelCurrenctWithdrawalId,

  // ------------ Documents -------------------------------
  setDocumentsData,
  setDocumentsLoading,
  resetDocumentsState,
  setDocumentsIsAllCollapse,
  setDocumentsFiltered,
  setDocumentsFilteredText,

  // Validate Cancellation Documents
  setValidateCancelationValue,
  resetValidateCancelationState,

  // Validate Receipt Documents
  setValidateReceiptValue,
  resetValidateReceiptState,

  // Validate Tax Relief
  setValidateTaxReliefValue,
  resetValidateTaxReliefState,

  // Validate Carbon Forward
  setValidateCarbonForwardfValue,
  resetValidateCarbonForwardFile,

  // -------------------------- Transfers -------------------------------
  resetTransferState,
  setTransferLoading,
  setTransferData,
  setTransferFiltered,

  // Validate Transfer
  resetValidateTransferState,
  setValidateTransferValue,
  setRejectTransferValue,
  resetRejectTransferState,

  // --------------------------- Deposits --------------------------------
  resetAdminDepositsState,
  setAdminDepositsLoading,
  setAdminDepositsData,

  // --------------------------- Suppliers --------------------------------
  resetAdminSuppliersState,
  setAdminSuppliersLoading,
  setAdminSuppliersSuccess,
  setAdminSuppliersError
} = adminSlice.actions

export default adminSlice.reducer
